import { useRef } from "react";

export const useDragDrop = () => {
  const dragItemChapter = useRef();
  const dragOverItemChapter = useRef();
  const dragItemQuestion = useRef();
  const dragOverItemQuestion = useRef();

  // Chapter drag and drop
  const dragStartChapter = (e, position) => {
    dragItemChapter.current = position;
  };

  const dragEnterChapter = (e, position) => {
    dragOverItemChapter.current = position;
  };
  const dropChapter = (data) => (e) => {
    const copyListItems = [...data];
    const dragItemContent = copyListItems[dragItemChapter.current];
    copyListItems.splice(dragItemChapter.current, 1);
    copyListItems.splice(dragOverItemChapter.current, 0, dragItemContent);
    dragItemChapter.current = null;
    dragOverItemChapter.current = null;
    return copyListItems;
  };

  // Question drag and drop
  const dragStartQuestion = (e, position) => {
    dragItemQuestion.current = position;
  };

  const dragEnterQuestion = (e, position) => {
    dragOverItemQuestion.current = position;
  };

  const dropQuestion = (data, index) => (e) => {
    var copyListItems = [...data];
    const dragItemContent =
      copyListItems[index].questions[dragItemQuestion.current];
    copyListItems[index].questions.splice(dragItemQuestion.current, 1);
    copyListItems[index].questions.splice(
      dragOverItemQuestion.current,
      0,
      dragItemContent
    );
    dragItemQuestion.current = null;
    dragOverItemQuestion.current = null;
    return copyListItems;
  };

  return {
    dragStartChapter,
    dragEnterChapter,
    dropChapter,
    dragStartQuestion,
    dragEnterQuestion,
    dropQuestion,
  };
};
